import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { GN } from '../../../../gn';
import { DIC } from '../../../dic';

/**
 * Generated class for the EmployeevehPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-employeeveh',
  templateUrl: 'employeeveh.html',
})
export class EmployeevehPage {
  vehicles = []
  Organisations = []

  Group = []
  loadingData: boolean = true
  GroupElements = 0;
  clientNumber: number
  selectedArray = []
  checkallVeh: boolean
  checkOrg: boolean
  countVisible = 0;
  driverid = 0

  constructor(public navCtrl: NavController, public navParams: NavParams, public gn: GN, public dic: DIC) {
    this.vehicles = navParams.get('authemp')
    console.log(this.vehicles, 'this.vehicles')
    this.driverid = navParams.get('driverid')

  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad EmployeevehPage');
    this.loadData()
  }

  loadData() {
    var _that = this
    this.gn._Post('/api/gn/admin/getorg', { clientid: this.gn.crypt(this.gn.user.ClientId) }, function (_data) {
      _data.push({ id: 0, name: _that.dic.l["Ungroupped"] })
      _that.Group = []
      _that.Group.push({ id: 0, name: _that.dic.l["Ungroupped"], vehicles: [] })
      for (var i = 0; i < _data.length; i++) {
        _that.Group.push({ id: _data[i].id, name: _data[i].name, vehicles: [] })
        for (var j = 0; j < _that.vehicles.length; j++) {
          if (_that.vehicles[j].organisationid == _data[i].id) {
            _that.Group[_that.Group.length - 1].vehicles.push(_that.vehicles[j])
            _that.GroupElements++;
          }
        }
      }

      _that.resetSearch()
      _that.loadingData = false
    })
  }

  checkAll() {
    for (let i = 0; i <= this.vehicles.length; i++) {
      this.vehicles[i].checked == true;
    }

  }

  selectMember(data) {
    if (data.checked == true) {
      this.selectedArray.push(data.id);
    }
    else {
      for (let i = 0; i < this.selectedArray.length; i++) {
        if (this.selectedArray[i] == data.id) {
          this.selectedArray.splice(i, 1);
        }
      }
    }
  }


  selectAll() {
    this.checkallVeh = !this.checkallVeh
    if (this.checkallVeh == false) {
      this.selectedArray = []
      for (let i = 0; i < this.vehicles.length; i++) {
        this.vehicles[i].checked = false;
      }
      for (let i = 0; i < this.Group.length; i++) {
        if (this.Group[i].vehicles.length > 0) {
          this.Group[i].checked = false;
        }
      }
    }
    if (this.checkallVeh == true) {
      for (let i = 0; i < this.vehicles.length; i++) {
        this.selectedArray.push(this.vehicles[i].id)
        this.vehicles[i].checked = true;
      }
      for (let i = 0; i < this.Group.length; i++) {
        if (this.Group[i].vehicles.length > 0) {
          this.Group[i].checked = true;
        }
      }
    }
  }

  checkOrganisation() {
    for (let i = 0; i <= this.Group.length; i++) {
      this.Group[i].checked == true;
    }
  }

  selectOrg(a: any) {
    if (a.checked == true) {
      for (let i = 0; i < a.vehicles.length; i++) {
        this.selectedArray.push(a.vehicles[i].id);
        for (let m = 0; m < this.vehicles.length; m++) {
          if (a.vehicles[i].id == this.vehicles[m].id)
            this.vehicles[m].checked = true;
        }
      }

    }
    else {
      for (let y = 0; y < a.vehicles.length; y++) {
        for (let l = 0; l < this.selectedArray.length; l++) {
          if (this.selectedArray[l] == a.vehicles[y].id) {
            this.selectedArray.splice(l, 1);
          }

        }
        for (let m = 0; m < this.vehicles.length; m++) {
          if (a.vehicles[y].id == this.vehicles[m].id) {
            this.vehicles[m].checked = false;
          }
        }
      }
    }
  }


  resetSearch() {
    for (var i = 0; i < this.Group.length; i++) {
      this.Group[i].Visible = true
      this.Group[i].countShow = 0;

      for (let j = 0; j < this.Group[i].vehicles.length; j++) {
        this.Group[i].vehicles[j].Visible = true;
      }
    }
  }

  getItems(ev: any) {
    var val = ev.target.value;
    if (val == null) { val = '' }
    val = val.toLowerCase()
    this.searchVehLeft(val);

  }

  searchVehLeft(val) {
    if (val && val.trim() != '') {
      for (var i = 0; i < this.Group.length; i++) {
        var countshowvehicles = 0;
        for (let j = 0; j < this.Group[i].vehicles.length; j++) {
          if (this.Group[i].vehicles[j].code.indexOf(val) > -1) {
            this.Group[i].vehicles[j].Visible = true
            this.Group[i].Visible = true;
          }
          else {
            if (this.gn._latcyr(this.Group[i].vehicles[j].registration.toLowerCase()).indexOf(val) > -1 || this.gn._cyrlat(this.Group[i].vehicles[j].registration.toLowerCase()).indexOf(val) > -1) {
              this.Group[i].vehicles[j].Visible = true
              this.Group[i].Visible = true;
            }

            else {
              this.Group[i].vehicles[j].Visible = false
              this.Group[i].Visible = false;
              this.countVisible++;
              countshowvehicles++;
            }
          }
          this.Group[i].countShow = countshowvehicles
        }
      }
    }
    else {
      this.resetSearch()
    }
  }


  Save() {

    this.gn.loadWaiting();
    var _that = this
    var countveh = this.selectedArray.length
    var counthehpassed = 0
    for (let i = 0; i < this.selectedArray.length; i++) {
      if (this.selectedArray[i] + '' != '0') {
        _that.gn._Post('/api/gn/setauthorizedvehicleondriver',
          {
            vehid: _that.gn.crypt(_that.selectedArray[i]),
            did: _that.gn.crypt(_that.driverid),

          }, function (_data) {
            counthehpassed++
            if (countveh == counthehpassed) {
              _that.gn.loaderWaiting.dismiss();
              var _cb = _that.navParams.get('cb')
              _cb(_that.selectedArray)
              _that.navCtrl.pop()
            }
          })
      }
    }

  }

  ionViewWillUnload() {
    this.selectedArray = []
    for (let m = 0; m < this.vehicles.length; m++) {
      this.vehicles[m].checked = false;
    }
  }




}



// WEBPACK FOOTER //
// ./src/pages/settings/driversettings/employeeveh/employeeveh.ts